const AdalErrorCode = {
    NoUserLogin: 'AADSTS50058',
    InvalidResourceUrl: 'AADSTS50001',
    InvalidGrant: 'AADSTS65001', // "AADSTS65001: The user or administrator has not consented to use the application with ID."
};

export default AdalErrorCode;
